import React from 'react'

import { Box, LinearProgress, Typography } from '@material-ui/core'
import { LinearProgressProps } from '@material-ui/core/LinearProgress'

type Props = LinearProgressProps & { value: number }

const LinearProgressWithLabel: React.FC<Props> = (
  props: Props
): React.ReactElement => {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  )
}

export default LinearProgressWithLabel
